import { compose, either, has, prop, propOr } from 'ramda';
import { isNotEmpty } from 'ramda-extension';

export const selectSession = propOr({}, 'session');

export const selectAuthToken = compose(prop('authToken'), selectSession);
export const selectUser = compose(propOr({}, 'user'), selectSession);
export const selectProspectUser = compose(
  propOr({}, 'prospectUser'),
  selectSession
);
export const selectAuthOrProspectUser = (state) => {
  const authUser = selectUser(state);
  if (isNotEmpty(authUser)) return authUser;

  return selectProspectUser(state);
};

export const isAuthenticated = compose(has('id'), selectUser);
export const isProspectUser = compose(has('id'), selectProspectUser);
export const isAuthenticatedOrProspect = either(
  isAuthenticated,
  isProspectUser
);

export const selectMembershipReturnGame = compose(
  propOr({}, 'membershipReturnGame'),
  selectSession
);

export const selectSuperchargerFirstName = compose(
  propOr(null, 'superchargerFirstName'),
  selectSession
);

export const selectSuperchargerInviteToken = compose(
  propOr(null, 'superchargerInviteToken'),
  selectSession
);

export const selectSuperchargerPhoneNumber = compose(
  propOr(null, 'superchargerPhoneNumber'),
  selectSession
);

export const selectSuperchargerPhoneCountry = compose(
  propOr(null, 'superchargerPhoneCountry'),
  selectSession
);

// { show, code } - see setSuperchargerPromo.
export const selectSuperchargerPromo = compose(
  propOr(null, 'superchargerPromo'),
  selectSession
);

export const selectGeoLocation = compose(propOr({}, 'location'), selectSession);

export const selectPersistedIsQaTeam = compose(
  propOr(false, 'isQaTeam'),
  selectSession
);
